import React, { Component } from 'react'
import styled from 'styled-components'

const PanelLayout = styled.div`
`

const NoResults = styled.div`
	font-size: 18px;
	padding: 15px 10px;
`

export default {
	PanelLayout,
	NoResults,
}